import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-vote-meter',
    templateUrl: './vote-meter.component.html',
    styleUrls: ['./vote-meter.component.scss'],
})
export class VoteMeterComponent implements OnInit {
    @Input() statusColor = 'yes';
    @Input() isActive = false;
    @Input() percent = 0;

    degree: number = 1.8 * this.percent;
    arrowStyle = '';

    constructor() {}

    ngOnInit(): void {
        this.degree = 1.8 * this.percent;
        this.arrowStyle = `{ transform: rotate(${this.degree}deg) }`;
    }
}
